export const StressSunIcon = (): JSX.Element => (
  <svg width="171" height="156" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <ellipse cx="91.5" cy="86" rx="71.5" ry="61" fill="#FDDA05" />
      <path
        d="M27.337 68.595s1.906-9.373-.913-14.13c-2.851-4.81-9.157-2.87-12.134-7.603-3.34-5.31-.836-16.042-.836-16.042"
        stroke="#FDDA05"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M102.879 9.682a2 2 0 0 0-3.95.636l3.95-.636Zm-1.975.318c-1.974.318-1.974.317-1.974.316v-.001l-.001-.003v-.005l-.002-.006v.002l.007.057a5.893 5.893 0 0 1-.057 1.411c-.148.903-.536 1.96-1.478 2.825l2.707 2.945c1.784-1.64 2.472-3.618 2.718-5.123a9.773 9.773 0 0 0 .089-2.462 5.436 5.436 0 0 0-.02-.178l-.008-.059-.004-.021-.001-.009-.001-.004v-.001c0-.001 0-.002-1.975.316Zm-3.505 4.596c-.753.692-1.522.8-2.971.77-1.344-.028-3.528-.232-5.667.885l1.853 3.546c1.031-.54 2.017-.468 3.731-.433 1.61.034 3.787-.009 5.761-1.823l-2.707-2.945Zm-8.638 1.655c-2.142 1.12-3.496 3.088-4.122 5.076-.616 1.954-.617 4.213.328 6.018l3.544-1.855c-.33-.63-.442-1.74-.057-2.96.373-1.186 1.132-2.196 2.16-2.733L88.76 16.25Zm-3.794 11.094c.874 1.67 1.925 2.376 2.71 2.904.632.427.999.676 1.4 1.442l3.544-1.855c-.874-1.67-1.925-2.376-2.71-2.904-.633-.427-1-.676-1.4-1.442l-3.544 1.855ZM87.936 1.684a2 2 0 1 0-3.743 1.409l3.743-1.41Zm-1.871.704c-1.872.705-1.872.704-1.873.704v-.003l-.001-.002v.002l.01.027.046.135a11.691 11.691 0 0 1 .504 2.471c.14 1.574-.095 3.04-.973 4l2.953 2.7c2.01-2.2 2.18-5.077 2.004-7.055a15.69 15.69 0 0 0-.761-3.58 7.13 7.13 0 0 0-.032-.09l-.003-.007-.001-.004h-.001c0-.002 0-.002-1.872.702Zm-2.287 7.335c-.37.405-.832.645-1.534.818-.852.21-1.553.235-2.822.437-1.122.18-2.448.482-3.738 1.264-1.317.799-2.458 2.011-3.37 3.797l3.562 1.82c.615-1.205 1.272-1.827 1.882-2.197.638-.387 1.369-.586 2.294-.734.778-.124 2.113-.249 3.147-.503 1.184-.291 2.458-.829 3.532-2.004l-2.953-2.698Zm-11.464 6.316c-2.095 4.101-.08 8.11 2.137 10.896 2.283 2.868 5.343 5.188 6.853 6.326l2.407-3.194c-1.529-1.152-4.202-3.2-6.13-5.622-1.992-2.503-2.665-4.707-1.705-6.586l-3.562-1.82Zm8.99 17.222c1.867 1.408 3.323 1.725 4.531 1.987 1.025.223 1.8.39 2.972 1.273l2.408-3.194c-1.868-1.408-3.324-1.725-4.532-1.987-1.024-.223-1.8-.39-2.972-1.273l-2.407 3.194Z"
        fill="#FDDA05"
      />
      <g filter="url(#b)">
        <ellipse
          cx="62.293"
          cy="87.698"
          rx="7"
          ry="5"
          transform="rotate(3.508 62.293 87.698)"
          fill="#FB9378"
          fillOpacity=".38"
        />
      </g>
      <g filter="url(#c)">
        <ellipse
          rx="6.693"
          ry="5.382"
          transform="matrix(.97004 -.24295 .37745 .92603 114.285 84.745)"
          fill="#FB9378"
          fillOpacity=".38"
        />
      </g>
      <circle
        cx="72.785"
        cy="71.811"
        r="1.5"
        transform="rotate(3.508 72.785 71.81)"
        fill="#666"
      />
      <circle
        cx="101.854"
        cy="71.589"
        r="1.5"
        transform="rotate(3.508 101.854 71.589)"
        fill="#666"
      />
      <path
        d="M124.65 61.254c.63.947 1.657 2.928.411 3.757-1.245.829-2.6-.934-3.231-1.881-1.47-2.21-1.458-5.167-1.458-5.167s2.886 1.199 4.278 3.29ZM132.392 57.672c1.179 1.04 3.257 3.32 1.889 4.87-1.368 1.55-3.806-.32-4.985-1.36-2.751-2.427-3.789-6.38-3.789-6.38s4.281.572 6.885 2.87Z"
        fill="#AFDAF7"
      />
      <g filter="url(#d)">
        <path
          d="M75.017 87.532c-.009-1.234 1.09-2.187 2.313-2.025 2.53.334 6.61.797 9.625.771 2.977-.024 6.997-.543 9.499-.912 1.221-.18 2.334.756 2.343 1.99l.006.817c.008.99-.71 1.837-1.69 1.983-8.02 1.198-12.866 1.35-20.422.183a1.976 1.976 0 0 1-1.667-1.945l-.007-.862Z"
          fill="#FDFDFD"
        />
      </g>
    </g>
    <defs>
      <filter
        id="b"
        x="53"
        y="80.279"
        width="18.586"
        height="14.838"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="c"
        x="105.48"
        y="77.501"
        width="17.609"
        height="14.488"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="d"
        x="75.018"
        y="85.344"
        width="23.786"
        height="9.795"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0.25 0" />
        <feBlend in2="shape" result="effect1_innerShadow" />
      </filter>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h171v156H0z" />
      </clipPath>
    </defs>
  </svg>
);
